module.exports = __webpack_public_path__ + "img/07.b7a86eb0.jpg";